export default __webpack_public_path__ + "static/media/urban-nightmare.fa9b197d.png";